import { create } from 'zustand';
import type { AdminInfo, AdminRole } from '@/types/admin';

interface AdminState {
  admin: AdminInfo | null;
  isAuthenticated: boolean;
  isLoading: boolean;

  setAdmin: (admin: AdminInfo) => void;
  clearAdmin: () => void;
  setLoading: (loading: boolean) => void;
}

export const useAdminStore = create<AdminState>()((set) => ({
  admin: null,
  isAuthenticated: false,
  isLoading: true,

  setAdmin: (admin) =>
    set({
      admin,
      isAuthenticated: true,
      isLoading: false,
    }),

  clearAdmin: () =>
    set({
      admin: null,
      isAuthenticated: false,
      isLoading: false,
    }),

  setLoading: (loading) => set({ isLoading: loading }),
}));

export const selectIsSuperAdmin = (state: AdminState) =>
  state.admin?.role === ('super_admin' satisfies AdminRole);
